<div
  class="top d-flex justify-content-between align-content-center flex-column"
>
  <nav class="navbar login-navbar ms-lg-3">
    <img class="login-logo" src="assets/images/CDBlack.png" alt="NCS^ INDORE" />
  </nav>

  <div class="container">
    <div class="row justify-content-center align-items-center login-component">
      <!-- Left card (logo) -->
      <div class="col-lg-6 left-card">
        <div
          class="card left-card-img shadow-none bg-transparent rounded-0 mb-0"
          *ngIf="
            applicationLogo !== 0 && applicationLogo !== undefined;
            else fallbackLogo1
          "
        >
          <img
            src="{{ getDoc(applicationLogo) }}"
            class="applicatin-img"
            alt="application logo"
          />
        </div>

        <ng-template #fallbackLogo1>
          <div
            class="card shadow-none bg-transparent rounded-0 mb-0 left-card-img"
          >
            <img
              src="assets/images/CDBlack.png"
              width="500"
              alt="Fallback Logo"
            />
          </div>
        </ng-template>
      </div>

      <!-- Right card (form) -->
      <div class="col-lg-6 col-md-8 col-sm-10 col-12 righ-card-top">
        <div class="card-body right-card shadow mycardpadding">
          <div>
            <!-- Mobile-only app logo -->
            <div
              class="text-center w-100 align-content-center application-logo"
              *ngIf="applicationLogo !== 0 && applicationLogo !== undefined"
            >
              <img src="{{ getDocThumbnail(applicationLogo) }}" alt="AppLogo" />
            </div>

            <!-- App name -->
            <div class="text-center">
              <h1 class="login-application-name">{{ appName }}</h1>
            </div>

            <!-- Page heading -->
            <div class="text-center mb-1">
              <h5 class="pb-1">Sign Up</h5>
              <form-error [form]="form"></form-error>
            </div>

            <!-- Success state -->
            <div *ngIf="isLogin" class="alert alert-success text-center mt-2">
              You have been registered successfully! Your login ID is
              <strong>{{ form.data["loginId"] }}</strong
              >.
              <a routerLink="/login" class="fw-bold ms-1" style="color: #1191fa"
                >Sign in here</a
              >
            </div>

            <!-- Form -->
            <div class="form-body dropdown-pd-none" *ngIf="!isLogin">
              <form class="row" #uiForm="ngForm">
                <!-- Email -->
                <div class="col-12 mt-3">
                  <mat-form-field
                    appearance="outline"
                    class="w-100 no-wrap-asterisk"
                  >
                    <mat-label>Email Address</mat-label>
                    <input
                      matInput
                      [(ngModel)]="form.data['loginId']"
                      type="email"
                      id="loginId"
                      name="loginId"
                      [pattern]="emailPattern"
                      placeholder="Enter your Email ID"
                      required
                      #login="ngModel"
                    />
                    <mat-icon matPrefix class="text-secondary opacity-50"
                      >email</mat-icon
                    >
                  </mat-form-field>
                  <div *ngIf="login.errors && !iseValidFormSubmitted">
                    <small *ngIf="login.errors['pattern']" class="text-danger">
                      Please enter a valid email address.
                    </small>
                  </div>
                </div>

                <!-- Check Email button (step 1) -->
                <div class="col-12 mt-3" *ngIf="emailExists">
                  <button
                    mat-raised-button
                    color="primary"
                    type="submit"
                    (click)="checkEmail()"
                    [disabled]="!uiForm.valid"
                    class="w-100 fat-button shadow-sm"
                  >
                    <span class="fs-6 tracking-wider">Continue</span>
                    <mat-icon class="ms-1">arrow_forward</mat-icon>
                  </button>
                </div>

                <!-- Additional fields (step 2) -->
                <div *ngIf="!emailExists" [@formFieldsAnimation]>
                  <!-- First Name -->
                  <div class="col-12 mt-3">
                    <mat-form-field
                      appearance="outline"
                      class="w-100 no-wrap-asterisk"
                    >
                      <mat-label>First Name</mat-label>
                      <input
                        matInput
                        [(ngModel)]="form.data['firstName']"
                        type="text"
                        id="firstName"
                        name="firstName"
                        placeholder="Enter First Name"
                        required
                      />
                      <mat-icon matPrefix class="text-secondary opacity-50"
                        >person</mat-icon
                      >
                    </mat-form-field>
                  </div>

                  <!-- Last Name -->
                  <div class="col-12 mt-3">
                    <mat-form-field
                      appearance="outline"
                      class="w-100 no-wrap-asterisk"
                    >
                      <mat-label>Last Name</mat-label>
                      <input
                        matInput
                        [(ngModel)]="form.data['lastName']"
                        type="text"
                        id="lastName"
                        name="lastName"
                        placeholder="Enter Last Name"
                        required
                      />
                      <mat-icon matPrefix class="text-secondary opacity-50"
                        >person_outline</mat-icon
                      >
                    </mat-form-field>
                  </div>

                  <!-- Password -->
                  <div class="col-12 mt-3">
                    <mat-form-field
                      appearance="outline"
                      class="w-100 no-wrap-asterisk"
                    >
                      <mat-label>Password</mat-label>
                      <input
                        matInput
                        [type]="showPassword ? 'text' : 'password'"
                        id="password"
                        name="password"
                        placeholder="Enter Password"
                        [(ngModel)]="form.data['password']"
                        required
                      />
                      <mat-icon matPrefix class="text-secondary opacity-50"
                        >lock_open</mat-icon
                      >
                      <mat-icon
                        matSuffix
                        (click)="togglePasswordVisibility()"
                        class="cursor-pointer text-secondary opacity-75"
                        [matTooltip]="
                          showPassword ? 'Hide password' : 'Show password'
                        "
                        matTooltipPosition="above"
                      >
                        {{ showPassword ? "visibility" : "visibility_off" }}
                      </mat-icon>
                    </mat-form-field>
                  </div>

                  <!-- Sign Up button -->
                  <div class="col-12 mt-3">
                    <button
                      mat-raised-button
                      color="primary"
                      type="submit"
                      (click)="signup()"
                      [disabled]="!uiForm.valid"
                      class="w-100 fat-button shadow-sm"
                    >
                      <span class="fs-6 tracking-wider">Create Account</span>
                    </button>
                  </div>

                  <!-- Sign in link -->
                  <div class="col-12 text-center mt-4">
                    <p class="mb-0 text-muted">
                      Already have an account?
                      <a
                        routerLink="/login"
                        class="text-decoration-none fw-bold ms-1"
                        style="color: #3f51b5"
                      >
                        Sign in here
                      </a>
                    </p>
                  </div>
                </div>
              </form>
            </div>

            <!-- Org branding -->
            <div class="row mt-3">
              <div class="col-lg-12">
                <div class="w-100">
                  <div class="text-center">
                    <span class="login-managed-by">Managed by</span>
                    <span class="org-name">{{ orgName }}</span>
                  </div>
                  <div
                    class="row text-center"
                    *ngIf="
                      orgLogo !== 0 && orgLogo !== undefined;
                      else fallbackLogo
                    "
                  >
                    <a target="_blank" title="Org logo">
                      <img
                        class="org-logo"
                        src="{{ getDoc(orgLogo) }}"
                        alt=""
                      />
                    </a>
                  </div>
                  <ng-template #fallbackLogo>
                    <div class="row text-center">
                      <a target="_blank" title="NCS Indore">
                        <img
                          class="org-logo"
                          src="assets/images/CDBlack.png"
                          width="100px"
                        />
                      </a>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="footer py-3 mt-auto">
    <div class="container-fluid">
      <p class="text-center mb-0">
        <span class="text-muted">Powered by</span> NCS^ NO-CODE Platform Pvt.
        Ltd.
      </p>
    </div>
  </footer>
</div>
